import { render, staticRenderFns } from "./LayoutContentRendererDefault.vue?vue&type=template&id=06bebd44&"
import script from "./LayoutContentRendererDefault.vue?vue&type=script&lang=js&"
export * from "./LayoutContentRendererDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06bebd44')) {
      api.createRecord('06bebd44', component.options)
    } else {
      api.reload('06bebd44', component.options)
    }
    module.hot.accept("./LayoutContentRendererDefault.vue?vue&type=template&id=06bebd44&", function () {
      api.rerender('06bebd44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/components/layout-content-renderer/LayoutContentRendererDefault.vue"
export default component.exports